import { Box } from '@mui/material';
import { Hidden, styled } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';
import { shouldForwardPropExclude } from '@synergy/utils';

import { DetailSidebarHeader } from './detail-sidebar-header';

const Container = styled(Box, { shouldForwardProp: shouldForwardPropExclude('collapsed') })<{
    collapsed: boolean;
}>(({ theme, collapsed }) => ({
    width: collapsed ? 0 : 400,
    minWidth: collapsed ? 0 : 400,
    backgroundColor: theme.palette.grey[100],
    height: '100vh',
    overflow: 'hidden',

    ...(collapsed && {
        transition: 'width 0.1s ease-out',
    }),
}));

const StyledBox = styled(Box)(({ theme }) => ({
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    height: `calc(100% - ${theme.toolbar.height});`,
    overflow: 'auto',
    paddingBottom: 24,
}));

interface DetailSidebarProps {
    title: string;
    collapsed?: boolean;
}

// TODO: merge with activity sidebar #1537 https://gitlab.com/fusonic/pool/synergy/portal/-/issues/1537
export const DetailSidebar = (props: PropsWithChildren<DetailSidebarProps>): ReactElement => (
    <Hidden only={['xs', 'sm', 'md']}>
        <Container collapsed={props.collapsed ?? false}>
            <DetailSidebarHeader title={props.title} />
            <StyledBox>{props.children}</StyledBox>
        </Container>
    </Hidden>
);
